/* eslint-disable */
import { FunctionComponent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Dropdown from "../../components/ui/Dropdown";
import Modal from "../../components/ui/Modal";
import PaymentPageProps from "./Payment";
import { fetchingNeftBankDetails, shareNeftDetails } from "../../services/paymentOptions";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import {
  panDeclaration,
  remitterID,
  roundOffValue,
  selectedPurpose,
  selectedVendor,
  transactionId,
} from "../../store";
import { ToastContainer, toast } from "react-toastify";

export const Modals: FunctionComponent<PaymentPageProps.ModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  bankList,
  bankName,
  setBankName,
  accountNumber,
  setAccountNumber,
  ifscCode,
  setIfscCode,
  netBankingHandle,
  upiId,
  setUpiId,
  upiHandle,
  handleSendNetBankingLink,
  errorMessage,
  setUpiLinkId,
  setLinkAccountNumber,
  setLinkIfscCode,
  upiLinkId,
  ifscLink,
  accNumLink,
  sendUpiLinkHandle,
  neftBankDetails,
  onlyNeft,
  isLoading,
  vendorCode,
  selectedPurposeCode,
}) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [linkStep, setLinkStep] = useState<string>("start");
  const [bankDetails, setBankDetails] = useState<any>([]);
  const transactionNumber = useRecoilValue(transactionId);
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  // I know only these values that needs to reset. If you need extra kindly add below
  const resetVendor = useResetRecoilState(selectedVendor);
  const resetPurpose = useResetRecoilState(selectedPurpose);
  const resetPANDeclaration = useResetRecoilState(panDeclaration);
  const resetRoundOffValue = useResetRecoilState(roundOffValue);
  const resetRemitterID = useResetRecoilState(remitterID);
  const resetAllValues = () => {
    resetVendor();
    resetPurpose();
    resetPANDeclaration();
    resetRoundOffValue();
    resetRemitterID();
  };

  useEffect(() => {
    fetchingNeftBankDetails(vendorCode, onlyNeft)
      .then((response) => {
        setBankDetails(response?.data);
      })
      .catch((error) => console.error("ERROR", error));
  }, [isModalOpen]);

  const shareDetails = () => {
    shareNeftDetails(transactionNumber)
      .then((response: any) => {
        if (response && response?.success) {
          toast.success("Details shared to whatsapp");
        }
      })
      .catch((error: any) => {
        toast.error(error?.data?.error?.type);
      });
  };

  return (
    <div>
      <ToastContainer position="top-center" />
      <div id="neftModal">
        <Modal
          header="NEFT and RTGS Account Details"
          headerClass="font-bold flex my-4 text-[22px] pb-4 w-[500px] px-6 border-gray-300 justify-center"
          modalClass="bg-gray-200"
          visible={isModalOpen === "neft"}
          closeHandler={() => {
            setIsModalOpen("");
            setBankName("");
            setAccountNumber("");
            setIfscCode("");
            setUpiId("");
          }}
          closable={true}
        >
          <div className="flex flex-col items-center">
            <div className="flex flex-col space-y-3">
              <div className="flex space-x-3">
                <span className="font-bold text-gray-500">Account Holder Name:</span>
                <span className="font-semibold">{bankDetails?.accountHolderName}</span>
              </div>
              <div className="flex space-x-3">
                <span className="font-bold text-gray-500">Bank Name:</span>
                <span className="font-semibold">{bankDetails?.bankName}</span>
              </div>
              <div className="flex space-x-3">
                <span className="font-bold text-gray-500">Account Number:</span>
                <span className="font-semibold">{bankDetails?.accountNumber}</span>
              </div>
              <div className="flex space-x-3">
                <span className="font-bold text-gray-500">IFSC:</span>
                <span className="font-semibold">{bankDetails?.ifscCode}</span>
              </div>
            </div>
            <div className="mt-16">
              <Button
                className="border font-semibold border-blue-500 text-blue-600 w-[223px] h-[54px] rounded"
                bgColor="white"
                onClickHandler={() => {
                  shareDetails();
                }}
              >
                Share A/C Details
              </Button>
            </div>
            <div className="mt-2">
              {/* <span className="text-[14px] text-green-500 ">
                A/C details have been shared to remitter's mobile number.
              </span> */}
            </div>
            <div id="note" className="flex flex-col mt-10">
              <span className="text-[14px] text-blue-600 font-bold">Note:</span>
              <span className="text-[14px] text-blue-600 ">
                - The Payment should be made in the next 30 working hours.
              </span>
              <span className="text-[14px] text-blue-600 ">
                - Please make sure that the payment is being made from the remitter’s
              </span>
              <span className="text-[14px] text-blue-600 ">
                account only otherwise the transation might be rejected.
              </span>
              {!selectedPurposeCode?.purposeValue?.includes("Overseas") ? (
                <>
                  <span className="text-[14px] text-blue-600 ">
                    - Your payment status will get updated during banking hours,
                  </span>
                  <span className="text-[14px] text-blue-600 ">
                    For any queries, do reach us at hello@moneyhop.co
                  </span>
                </>
              ) : (
                <>
                  <span className="text-[14px] text-blue-600 ">
                    - After making the bank transfer,it may take up to 1 hour
                  </span>
                  <span className="text-[14px] text-blue-600 ">
                    to get the payment status updated.
                  </span>
                </>
              )}
              <span className="text-[14px] text-blue-600 ">
                - Optional- You can upload the payment proof after the fund transfer in the History
                tab
              </span>
            </div>
            <div className="flex flex-col mt-10 space-y-4">
              <Button
                onClickHandler={() => {
                  navigate("/confirmation");
                  resetAllValues();
                }}
                className="font-semibold text-white w-[223px] h-[54px] rounded"
                bgColor="bg-primary-1050"
              >
                Confirm
              </Button>
              <Button
                onClickHandler={() => {
                  navigate("/home");
                }}
                className="font-semibold text-primary-1050 w-[223px] h-[54px]"
                bgColor="white"
              >
                Go Home
              </Button>
            </div>
          </div>
        </Modal>
      </div>
      <div id="netBanking">
        <Modal
          header="Net Banking"
          headerClass="font-bold flex my-4 text-[22px] pb-4 w-[600px] px-6 border-gray-300 justify-center"
          modalClass="bg-gray-200"
          visible={isModalOpen === "netBanking"}
          closeHandler={() => {
            setIsModalOpen("");
            setBankName("");
            setAccountNumber("");
            setIfscCode("");
            setUpiId("");
          }}
          closable={true}
        >
          <div className="flex flex-col items-center mt-20 space-y-12">
            <Dropdown
              showDropdown={showDropdown}
              dropdownButtonOnClick={() => setShowDropdown((prev) => !prev)}
              dropdownLabel="Select Your Bank*"
              list={bankList}
              dropdownValue={bankName}
              listItemOnClick={(e) => {
                e.stopPropagation();
                setBankName(e.target.textContent);
                setShowDropdown(false);
              }}
              dropdownBodyClassname="border-black border-2 bg-white"
              dropdownClassname="bg-white"
            />
            <div>
              <input
                name="accountNumber"
                type="number"
                placeholder="Enter your Account Number*"
                onChange={(e) => setAccountNumber(e.target.value)}
                value={accountNumber}
                style={{ width: "380px", height: "50px", padding: "8px" }}
                required
                pattern={specialCharRegExp}
              />
            </div>
            <div>
              <input
                name="ifscCode"
                type="text"
                placeholder="Enter your IFSC Code*"
                onChange={(e) => setIfscCode(e.target.value)}
                value={ifscCode}
                style={{ width: "380px", height: "50px", padding: "8px" }}
                required
                autoComplete="off"
                pattern={specialCharRegExp}
              />
            </div>
            <div>
              <Button
                isLoading={isLoading}
                onClickHandler={netBankingHandle}
                className="font-semibold text-white w-[223px] h-[54px] rounded"
                bgColor="bg-primary-1050"
              >
                Confirm
              </Button>
              <Button
                onClickHandler={() => navigate("/home")}
                className="font-semibold text-primary-1050 w-[223px] h-[54px]"
                bgColor="white"
              >
                Go Home
              </Button>
            </div>
            <span className="text-[14px] font-semibold text-red-500">
              {errorMessage && errorMessage}
            </span>
          </div>
        </Modal>
      </div>
      <div id="link">
        <Modal
          header="Generate Payment Link"
          headerClass="font-bold flex my-4 text-[22px] pb-4 w-[600px] px-6 border-gray-300 justify-center"
          modalClass="bg-gray-200"
          visible={isModalOpen === "link"}
          closeHandler={() => {
            setIsModalOpen("");
            setBankName("");
            setAccountNumber("");
            setIfscCode("");
            setUpiId("");
          }}
          closable={true}
        >
          <div>
            {linkStep === "start" && (
              <div className="flex justify-center space-x-8">
                <div
                  onClick={() => setLinkStep("netBankingLink")}
                  className="p-3 border border-gray-400 rounded-lg cursor-pointer hover:bg-gray-100 hover:border-black"
                >
                  Net Banking
                </div>
                {/* <div
                  onClick={() => setLinkStep("upiLink")}
                  className="p-3 border border-gray-400 rounded-lg cursor-pointer hover:bg-gray-100 hover:border-black"
                >
                  UPI
                </div> */}
              </div>
            )}
            {linkStep === "netBankingLink" && (
              <div className="flex flex-col items-center mt-20 space-y-12">
                <Dropdown
                  showDropdown={showDropdown}
                  dropdownButtonOnClick={() => setShowDropdown((prev) => !prev)}
                  dropdownLabel="Select Your Bank*"
                  list={bankList}
                  dropdownValue={bankName}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    setBankName(e.target.textContent);
                    setShowDropdown(false);
                  }}
                  dropdownBodyClassname="border-black border-2 bg-white"
                  dropdownClassname="bg-white"
                />
                <div>
                  <input
                    name="accountNumber"
                    type="number"
                    placeholder="Enter your Account Number*"
                    onChange={(e) => setAccountNumber(e.target.value)}
                    value={accountNumber}
                    style={{ width: "380px", height: "50px", padding: "8px" }}
                    required
                    pattern={specialCharRegExp}
                  />
                </div>
                <div>
                  <input
                    name="ifscCode"
                    type="text"
                    placeholder="Enter your IFSC Code*"
                    onChange={(e) => setIfscCode(e.target.value)}
                    value={ifscCode}
                    style={{ width: "380px", height: "50px", padding: "8px" }}
                    required
                    autoComplete="off"
                    pattern={specialCharRegExp}
                  />
                </div>
                <div>
                  <Button
                    isLoading={isLoading}
                    onClickHandler={handleSendNetBankingLink}
                    className="font-semibold text-white w-[223px] h-[54px] rounded"
                    bgColor="bg-primary-1050"
                  >
                    Confirm
                  </Button>
                  <Button
                    onClickHandler={() => navigate("/remittance")}
                    className="font-semibold text-primary-1050 w-[223px] h-[54px]"
                    bgColor="white"
                  >
                    Go Home
                  </Button>
                </div>
                <span className="text-[14px] font-semibold text-red-500">
                  {errorMessage && errorMessage}
                </span>
              </div>
            )}
            {linkStep === "upiLink" && (
              <div className="flex flex-col items-center mt-12">
                <div className="flex flex-col space-y-8 w-[383px]">
                  <input
                    name="upiId"
                    type="text"
                    placeholder="Enter UPI ID"
                    onChange={(e) => setUpiLinkId(e.target.value)}
                    value={upiLinkId}
                    style={{ width: "380px", height: "50px", padding: "8px" }}
                    required
                    autoComplete="off"
                    pattern={specialCharRegExp}
                  />
                  <input
                    name="accNum"
                    type="text"
                    placeholder="Enter your Account Number*"
                    onChange={(e) => setLinkAccountNumber(e.target.value)}
                    value={accNumLink}
                    style={{ width: "380px", height: "50px", padding: "8px" }}
                    required
                    autoComplete="off"
                    pattern={specialCharRegExp}
                  />
                  <input
                    name="ifsc"
                    type="text"
                    placeholder="Enter your IFSC Code*"
                    onChange={(e) => setLinkIfscCode(e.target.value)}
                    value={ifscLink}
                    style={{ width: "380px", height: "50px", padding: "8px" }}
                    required
                    autoComplete="off"
                    pattern={specialCharRegExp}
                  />
                </div>
                <div className="mt-[200px]">
                  <Button
                    isLoading={isLoading}
                    onClickHandler={sendUpiLinkHandle}
                    className="font-semibold text-white w-[223px] h-[54px] rounded"
                    bgColor="bg-primary-1050"
                  >
                    Confirm
                  </Button>
                  <Button
                    onClickHandler={() => navigate("/home")}
                    className="font-semibold text-primary-1050 w-[223px] h-[54px]"
                    bgColor="white"
                  >
                    Go Home
                  </Button>
                </div>
                <span className="text-[14px] font-semibold text-red-500">
                  {errorMessage && errorMessage}
                </span>
              </div>
            )}
          </div>
        </Modal>
      </div>
      <div id="upiModal">
        <Modal
          header="UPI"
          headerClass="font-bold flex my-4 text-[22px] pb-4 w-[600px] px-6 border-gray-300 justify-center"
          modalClass="bg-gray-200"
          visible={isModalOpen === "upi"}
          closeHandler={() => {
            setIsModalOpen("");
            setBankName("");
            setAccountNumber("");
            setIfscCode("");
            setUpiId("");
          }}
          closable={true}
        >
          <div className="flex flex-col items-center mt-12">
            <div className="flex flex-col space-y-8 w-[383px]">
              <input
                name="upiId"
                type="text"
                placeholder="Enter UPI ID"
                onChange={(e) => setUpiId(e.target.value)}
                value={upiId}
                style={{ width: "380px", height: "50px", padding: "8px" }}
                required
                autoComplete="off"
                pattern={specialCharRegExp}
              />
              <input
                name="accNum"
                type="text"
                placeholder="Enter your Account Number*"
                onChange={(e) => setAccountNumber(e.target.value)}
                value={accountNumber}
                style={{ width: "380px", height: "50px", padding: "8px" }}
                required
                autoComplete="off"
                pattern={specialCharRegExp}
              />
              <input
                name="ifsc"
                type="text"
                placeholder="Enter your IFSC Code*"
                onChange={(e) => setIfscCode(e.target.value)}
                value={ifscCode}
                style={{ width: "380px", height: "50px", padding: "8px" }}
                required
                autoComplete="off"
                pattern={specialCharRegExp}
              />
            </div>
            <div className="mt-[200px]">
              <Button
                onClickHandler={upiHandle}
                className="font-semibold text-white w-[223px] h-[54px] rounded"
                bgColor="bg-primary-1050"
              >
                Confirm
              </Button>
              <Button
                onClickHandler={() => navigate("/home")}
                className="font-semibold text-primary-1050 w-[223px] h-[54px]"
                bgColor="white"
              >
                Go Home
              </Button>
              <span className="text-[14px] font-semibold text-red-500">
                {errorMessage && errorMessage}
              </span>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};
